import { render } from "./MilestoneModulesKanban.vue?vue&type=template&id=686f77ce&scoped=true&ts=true"
import script from "./MilestoneModulesKanban.vue?vue&type=script&lang=ts"
export * from "./MilestoneModulesKanban.vue?vue&type=script&lang=ts"

import "./MilestoneModulesKanban.vue?vue&type=style&index=0&id=686f77ce&lang=scss"
import "./MilestoneModulesKanban.vue?vue&type=style&index=1&id=686f77ce&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686f77ce"]])

export default __exports__